import { animated, SpringValue } from '@react-spring/web';

import { DateOfBirthPicker } from '@app/shared/ui/organisms/Common';
import { defaultPandaImage } from '@app/assets';

interface PandaDateSelectProps {
  spring: { transform: SpringValue<string> };
  labelTranslationKey: string;
  pandaIcon?: string | null;
  date?: Date;
  setDate: (date?: Date) => void;
}

export function PandaDateSelect({
  spring,
  labelTranslationKey,
  pandaIcon,
  date,
  setDate,
}: PandaDateSelectProps) {
  return (
    <div className="grid grid-rows-[1fr_auto] gap-10">
      <animated.div style={spring} className="aspect-square h-full">
        <img
          src={pandaIcon || defaultPandaImage}
          alt="panda icon"
          className="h-full w-full object-contain"
        />
      </animated.div>
      <DateOfBirthPicker date={date} setDate={setDate} labelTranslationKey={labelTranslationKey} />
    </div>
  );
}
